import React from "react";
import Erreur404 from "./erreur404";

export const E404 =()=>{
    return(
        <Erreur404/>
    )
}